// Camera: how close the picture is framed, and who it points at. The first pick adds a camera marker at t (or changes the
// one being edited), and every pick after changes it.
import { cameraAt, markById, onScreen } from "../../../model/timeline";
import { Section } from "../../common";
import { useTimeline } from "../TimelineLoader";
import type { PageProps } from "./index";
import { CameraTiles } from "./LineStartSections";
import { PageShell, useMarkerSave } from "./shared";

export function CameraPage({ t, editId, onClose }: PageProps) {
  const { ep } = useTimeline();
  const editing = editId ? markById(ep, "camera", editId) : undefined;
  const save = useMarkerSave("camera", t, editing?.id);
  return (
    <PageShell title="Camera" t={t} editing={!!editing} onClose={onClose}>
      <Section title="Framing" hint={onScreen(ep, t).length ? undefined : "Medium and close-up need someone on screen. Place a face on the picture first (select it, then Faces)."}>
        <CameraTiles ep={ep} t={t} people={onScreen(ep, t)} cur={editing ?? cameraAt(ep, t)} onPick={save} />
      </Section>
    </PageShell>
  );
}
